import '@ionic/core/css/core.css';
import '@ionic/core/css/structure.css';
import './styles/theme.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App, { preloadPage } from './App';
import { startErrorReports } from './lib/errorReport';
import { APP_NAME, isNative } from './lib/platform';
import { loadServerInfo } from './lib/serverInfo';

startErrorReports();
// index.html, and the pages the server writes out, carry longer titles for search results; a tab of the
// app itself is named after the product. Set before the first page draws, so a page can name itself.
document.title = APP_NAME;

// The server writes the words of some pages (the privacy policy, the terms)
// into their HTML. The app draws over them once it has their code and the
// facts they are written from, so that one copy replaces the other with no
// "Loading" in between. It waits a little at most, never for a slow server.
if (['/privacy', '/terms', '/delete-account'].includes(window.location.pathname)) {
  await Promise.race([Promise.all([preloadPage(window.location.pathname), loadServerInfo().catch(() => null)]), new Promise((resolve) => setTimeout(resolve, 3000))]);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The service worker caches the app shell so repeat visits open instantly,
// even on a slow network (E6-S9). Native apps ship the files in the bundle.
if (!isNative && import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Test builds only: lets the automated native tests drive the app.
if (import.meta.env.VITE_AUTOMATION) {
  void import('./automation').then((m) => m.startAutomation(import.meta.env.VITE_AUTOMATION!));
}
